import { TRankIcon } from '../../../types';

import bidRankIcons from './icons';

/**
 * @deprecated
 */
interface IBidRankBadgeProps {
  icon: TRankIcon | (() => TRankIcon | null) | null;
}

/**
 * -----------------------------------------------------------------------------
 * Component Will accept icon string and return corresponding svg icon
 * @deprecated - Instead use `BidRankIcon`.
 */
export function BidRankBadgeOld({ icon }: IBidRankBadgeProps) {
  const iconIndex = typeof icon === 'function' ? icon() : icon;

  if (iconIndex) {
    const RankIcon = bidRankIcons[iconIndex];
    return <RankIcon />;
  }
  return null;
}
